// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gl-0";
export var actionModalContentContainer = "_gl-1";
export var createTagButton = "_gl-2";
export var footerContainer = "_gl-7";
export var fullWidthDivider = "_gl-3";
export var hasCreateTagButton = "_gl-4";
export var noCreateTagButton = "_gl-5";
export var tagsContainer = "_gl-6";
export var tagsModalContentContainer = "_gl-8";